import { z } from "zod";

export const oauthRefreshSchema = z.object({
  access_token: z.string(),
  expires_at: z.string(),
  refresh_token: z.string(),
});

export type OauthRefresh = z.infer<typeof oauthRefreshSchema>;
